import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import auth from './modules/auth'
import comments from './modules/comments'
import contents from './modules/contents'
import countries from './modules/countries'
import folders from './modules/folders'
import notifications from './modules/notifications'
import settings from './modules/settings'
import tags from './modules/tags'
import teams from './modules/teams'
import common from './modules/common'
import clients from './modules/clients'
import users from './modules/users'
import invitations from './modules/invitations'
import memberships from './modules/memberships'
import ownerships from './modules/ownerships'
import mailings from './modules/mailings'
import demoForm from './modules/demoForm'

Vue.use(Vuex)

const modules = {
  ...app,
  ...auth,
  ...comments,
  ...contents,
  ...countries,
  ...folders,
  ...notifications,
  ...settings,
  ...tags,
  ...teams,
  ...common,
  ...clients,
  ...users,
  ...invitations,
  ...memberships,
  ...ownerships,
  ...mailings,
  ...demoForm
}

export default new Vuex.Store({
  strict: process.env.VUEX_STRICT_MODE,
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js